// extracted by mini-css-extract-plugin
export default {"root":"Ref_root__QGpaj","module-name":"Ref_module-name__JzYJZ","moduleName":"Ref_module-name__JzYJZ"};